import { Typography, Box, Stack } from "@mui/material";

export default function FreePackRewardsSettings({ rawData }) {
  if (!rawData) {
    return (
      <Typography color="error" variant="body2">
        Invalid or empty JSON data
      </Typography>
    );
  }
  return (
    <Stack spacing={1} sx={{ p: 4, flex: 1, justifyContent: 'center' }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 1,
      }}>
        <Typography variant="body2" sx={{
          color: 'text.secondary',
          fontSize: '0.7rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
        }}>
          Time Period:
        </Typography>
        <Typography variant="subtitle1" sx={{
          fontWeight: 700,
          color: 'text.primary',
          fontSize: '0.8rem',
        }}>
          {rawData ? `${String(rawData.hours)} hours` : "No data"}
        </Typography>
      </Box>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 1,
      }}>
        <Typography variant="body2" sx={{
          color: 'text.secondary',
          fontSize: '0.7rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
        }}>
          Reward:
        </Typography>
        <Typography variant="subtitle1" sx={{
          fontWeight: 700,
          color: 'text.primary',
          fontSize: '0.8rem',
        }}>
          {rawData ? `${String(rawData.amount)} ${String(rawData.type)}` : "No data"}
        </Typography>
      </Box>
    </Stack>
  )
}
